import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { TablePaginate, PaginateEvent } from '../../classes/table-paginate';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.css']
})
export class PaginatorComponent implements OnInit, OnChanges {

    @Input() pagination: TablePaginate;
    @Output() pageEvent = new EventEmitter();
    itemCountSelector: any[];

    disabledPrevious = false;
    disabledNext = false;

    constructor() { }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.pagination && changes.pagination.currentValue) {
            this.processEtatBtn(changes.pagination.currentValue);
        }
    }

    processEtatBtn(paginator: TablePaginate) {
        if (paginator.last === paginator.current) {
            this.disabledNext = true;
        } else {
            this.disabledNext = false;
        }

        if (paginator.first === paginator.current) {
            this.disabledPrevious   = true;
        } else {
            this.disabledPrevious   = false;
        }
    }

    sendPageEvent(event: string) {
        switch (event) {
            case 'Next':
                this.pagination.current++;
                break;

            case 'Previous':
                this.pagination.current--;
                break;

            case 'Last':
                this.pagination.current = this.pagination.last;
                break;

            case 'First':
                this.pagination.current = this.pagination.first;
                break;
        }
        this.pageEvent.emit(event);
    }

}
